// extracted by mini-css-extract-plugin
module.exports = {"results":"styles_results__2HOAT","error":"styles_error__VCjyo","errorDescription":"styles_errorDescription__1jksJ"};